module.exports = __webpack_public_path__ + "static/media/image-card-2.be3a6928.png";